export default "__VITE_ASSET__noFUk$wJ__"